import React from "react";
import { CheckCircle2 } from "lucide-react";
import { IMAGES, COMPANY } from "../../lib/site-data";

const POINTS = [
  "Dependable workmanship from a licensed local plumber",
  "Honest, up-front pricing — no hidden fees",
  "Family-owned, neighbor-trusted in Conway, AR",
  "Residential & small commercial — big or small, we show up",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="absolute -inset-4 bg-[#F3F4F6] rounded-3xl rotate-2"></div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-[#1D2B53]/10">
              <img
                src={IMAGES.owner}
                alt={`${COMPANY.owner}, owner of Taylor Made Plumbing & Services`}
                className="w-full h-[480px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1D2B53] to-transparent p-6">
                <div className="text-white">
                  <div className="text-xs uppercase tracking-[0.2em] text-[#FBBF24] font-bold">
                    Meet The Owner
                  </div>
                  <div className="font-display text-2xl font-bold mt-1">
                    {COMPANY.owner}
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 lg:-right-8 bg-[#2563EB] text-white rounded-2xl px-6 py-4 shadow-xl shadow-blue-500/30 rotate-3">
              <div className="text-3xl font-display font-black">A+</div>
              <div className="text-xs uppercase tracking-wider font-semibold">
                Quality Work
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-4">
              About Taylor Made
            </div>
            <h2
              data-testid="about-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1D2B53] tracking-tight leading-tight"
            >
              A name your neighbors trust for plumbing done right.
            </h2>
            <p className="mt-6 text-lg text-gray-600 leading-relaxed">
              Taylor Made Plumbing &amp; Services is a family-owned shop based in Conway, Arkansas,
              led by Jason Taylor. We built this business on the belief that good plumbing comes from
              honesty, real craftsmanship, and showing up when we say we will.
            </p>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              From bathroom remodels to routine drain cleanings,
              we serve homeowners and small businesses across Conway and the surrounding Arkansas
              communities — with fair pricing and quality you can stand behind.
            </p>

            <ul className="mt-8 space-y-3" data-testid="about-feature-list">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="h-6 w-6 text-[#2563EB] shrink-0 mt-0.5" strokeWidth={2} />
                  <span className="text-base text-[#1D2B53] font-medium">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
